import { SupportStatus } from '@/types/home';
import { useFm } from '@web3/base-hooks';

import styles from './index.module.scss';

export type IProps = {
  status: SupportStatus;
};
export const StatusTag = (props: IProps) => {
  const { status } = props;
  const fm = useFm();

  const statusLable = {
    [SupportStatus.NO_RESP]: fm('noResponse'),
    [SupportStatus.PARTIAL_SUPPORT]: fm('partiallySupported'),
    [SupportStatus.REJECT_PROVIDE]: fm('rejectSupport'),
    [SupportStatus.ALL_LOST]: fm('allLost'),
    [SupportStatus.FREEZED]: fm('frozen'),
    [SupportStatus.PROVIDED_NEXT_ADDRESS]: fm('providedNextDest'),
    [SupportStatus.FULL_PROVIDED]: fm('fullySupported'),
  };

  const handleColor = (status: SupportStatus) => {
    const redStatus = [
      SupportStatus.NO_RESP,
      SupportStatus.REJECT_PROVIDE,
      SupportStatus.ALL_LOST,
    ];
    const greenStatus = [
      SupportStatus.FREEZED,
      SupportStatus.FULL_PROVIDED,
      SupportStatus.PROVIDED_NEXT_ADDRESS,
    ];
    const yellowStatus = [SupportStatus.PARTIAL_SUPPORT];

    if (redStatus.includes(status)) {
      return {
        bgColor: 'rgba(239, 69, 74, 0.16)',
        color: '#EF454A',
      };
    }

    if (greenStatus.includes(status)) {
      return {
        bgColor: 'rgba(32, 178, 108, 0.16)',
        color: '#20B26C',
      };
    }

    if (yellowStatus.includes(status)) {
      return {
        bgColor: 'rgba(247, 166, 0, 0.12)',
        color: '#F7A600',
      };
    }
  };

  const { bgColor, color } = handleColor(status);

  return (
    <div
      className={styles.container}
      style={{ backgroundColor: bgColor, color }}
    >
      {statusLable[status]}
    </div>
  );
};
